import moment from "moment";
import { jwtDecode } from "jwt-decode";

// ---------------------------------------------------------------------------
// Stałe kolumn tabeli
// ---------------------------------------------------------------------------

export const columns = [
  // { id: "select", label: "Wybór", minWidth: 50 },
  { id: "history", label: "Historia", Width: 50 },
  { id: "edit", label: "Edit", minWidth: 50 },
  { id: "info", label: "Info", minWidth: 50 },
  { id: "znaczniki", label: "Znaczniki", minWidth: 50 },
  { id: "statusRealizacji", label: "Status", minWidth: 170 },
  { id: "nrRef", label: "Nr. Ref", minWidth: 170 },
  { id: "importer", label: "Importer", minWidth: 170 },
  { id: "eksporter", label: "Eksporter", minWidth: 170 },
  { id: "rodzaj", label: "Rodzaj", minWidth: 170 },
  {
    id: "osobaWysylajacaOdprawe",
    label: "Osoba wysyłająca odprawę",
    minWidth: 170,
  },
  {
    id: "osobaPrzygotowujacaOdprawe",
    label: "Osoba przygotowujaca odprawę",
    minWidth: 170,
  },
  {
    id: "osobaWeryfikujacaOdprawe",
    label: "Osoba weryfikująca odprawę",
    minWidth: 170,
  },
  { id: "listaKontrolna", label: "Lista kontrolna", minWidth: 170 },
  { id: "SAD", label: "SAD", minWidth: 130 },
  { id: "nrAuta", label: "Nr. Auta", minWidth: 170 },
  { id: "lokalizacjaTowaru", label: "Lok. Towaru", minWidth: 170 },
  { id: "dokumenty", label: "Dokumenty", minWidth: 170 },
  { id: "dataT1", label: "Data wygaśnięcia T1", minWidth: 170 },
  { id: "utworzono", label: "Data utworzenia", minWidth: 150 },
  { id: "endDate", label: "Data zakończenia", minWidth: 150 },
  { id: "ileWSystemie", label: "Ile w systemie", minWidth: 170 },
  { id: "usun", label: "Usuń", minWidth: 170 },
];

export const generateFilteredColumns = (role) => {
  const originalColumns = [
    // { id: "select", label: "Wybór", minWidth: 50 },
    { id: "history", label: "Historia", Width: 50 },
    { id: "edit", label: "Edit", minWidth: 50 },
    { id: "info", label: "Info", minWidth: 50 },
    { id: "znaczniki", label: "Znaczniki", minWidth: 50 },
    { id: "statusRealizacji", label: "Status", minWidth: 170 },
    { id: "nrRef", label: "Nr. Ref", minWidth: 170 },
    { id: "importer", label: "Importer", minWidth: 170 },
    { id: "eksporter", label: "Eksporter", minWidth: 170 },
    { id: "rodzaj", label: "Rodzaj", minWidth: 170 },
    {
      id: "osobaPrzygotowujacaOdprawe",
      label: "Osoba przygotowujaca odprawę",
      minWidth: 170,
    },
    {
      id: "osobaWeryfikujacaOdprawe",
      label: "Osoba weryfikująca odprawę",
      minWidth: 170,
    },
    {
      id: "osobaWysylajacaOdprawe",
      label: "Osoba wysyłająca odprawę",
      minWidth: 170,
    },
    {
      id: "osobaMonitorujacaOdprawe",
      label: "Osoba monitorująca odprawę",
      minWidth: 170,
    },
    { id: "SAD", label: "SAD", minWidth: 130 },
    { id: "nrAuta", label: "Nr. Auta", minWidth: 170 },
    { id: "lokalizacjaTowaru", label: "Lok. Towaru", minWidth: 170 },
    { id: "adresatDokumentow", label: "Adresat dokumentów", minWidth: 170 },
    { id: "dokumenty", label: "Dokumenty", minWidth: 170 },
    { id: "dataT1", label: "Data wygaśnięcia T1", minWidth: 170 },
    { id: "utworzono", label: "Data utworzenia", minWidth: 150 },
    { id: "endDate", label: "Data zakończenia", minWidth: 150 },
    { id: "ileWSystemie", label: "Ile w systemie", minWidth: 170 },
    { id: "usun", label: "Usuń", minWidth: 170 },
  ];

  if (role === "admin" || role === "menager") {
    return originalColumns;
  } else {
    return originalColumns.filter((column) => column.id !== "usun");
  }
};

// ---------------------------------------------------------------------------
// Wartości list rozwijanych
// ---------------------------------------------------------------------------

export const statusValues = [
  "Wszystko",
  "Do przygotowania",
  "Wstępnie przygotowane",
  "Przygotowane",
  "Do weryfikacji",
  "Do wysłania",
  "Wysłane",
  "Unieważnione przez OC",
  "Odprawa zakończona",
  "Zrealizowane",
  "Anulowane",
];

export const rodzajValues = [
  "Wszystko",
  "Import",
  "Eksport",
  "Tranzyt",
  "Wyprowadzenie ze składu",
  "Wprowadzenie na skład",
  "Uszlachetnianie czynne",
  "Uszlachetnianie bierne",
  "Powrotny przywóz",
  "Powrotny wywóz",
  "Eksport - wpis do rejestru",
  "Import - wpis do rejestru",
  "Eksport PL i import inny kraj",
];

export const rodzajTransportuOptions = [
  "Wszystko",
  "Kurier",
  "Na Kołach",
  "W drodze",
  "Kurier MU MAN zakład",
  "Kurier MU VOLKSWAGEN MOTOR POLSKA",
  "Magazyn Warszawa",
  "Zakończono",
];

export const yesOrNo = ["Wszystko", "Tak", "Nie"];

// ---------------------------------------------------------------------------
// Funkcje pomocnicze
// ---------------------------------------------------------------------------

export const calculateDifferenceString = (createdAt, status) => {
  if (
    status === "Zrealizowane" ||
    status === "Unieważnione przez OC" ||
    status === "zrealizowane" ||
    status === "Anulowane" ||
    status === "Tranzyt zakończony"
  ) {
    return "Zakończono";
  }

  const now = moment();
  const createdDate = moment(createdAt);
  const difference = now.diff(createdDate);

  const duration = moment.duration(difference);
  const months = duration.months();
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();

  if (months > 0) {
    return `${months}m ${days}d ${hours}h ${minutes}m`;
  } else if (days >= 1) {
    return `${days}d ${hours}h ${minutes}m`;
  } else {
    return `${hours}h ${minutes}m`;
  }
};

export function checkUsername() {
  const token = localStorage.getItem("token");

  if (typeof token === "string") {
    try {
      const decoded = jwtDecode(token);
      const username = decoded.username;
      const role = decoded.role;

      const allowedRoles = ["admin", "manager"];
      const targetUsernames = [
        "adobrowolska",
        "ahrechaniuk",
        "dczernikowska",
        "molszewska",
        "mjakubowska",
        "dzabicka",
        "mkarykowska",
        "awiertelak",
        "mlalik",
      ];

      if (allowedRoles.includes(role) || targetUsernames.includes(username)) {
        return true;
      } else {
        console.warn("Access denied: Neither role nor username is valid.");
        return false;
      }
    } catch (error) {
      console.error("Error decoding token:", error);
      return false;
    }
  } else {
    console.error("Token is not available or invalid.");
    return false;
  }
}

export function checkUsernameAdmin() {
  const token = localStorage.getItem("token");

  if (typeof token === "string") {
    const decoded = jwtDecode(token);
    const role = decoded.role;
    return ["admin"].includes(role);
  } else {
    return false;
  }
}

// ---------------------------------------------------------------------------
// Domyślny pusty obiekt filtrów
// ---------------------------------------------------------------------------

export const EMPTY_FILTERS = {
  nrRefFilter: "",
  nrFakturyFilter: "",
  dateFilter: "",
  importerFilter: "",
  eksporterFilter: "",
  autoFilter: "",
  MRNFilter: "",
  SADFilter: "",
  adresatDokumentow: "",
  searchText: "",
  startDate: "",
  endDate: "",
  dataUtworzeniaFilter: "",
  dataZakonczeniaFilter: "",
  dataZakonczenia1Filter: "",
  dataUtworzenia1Filter: "",
  dataUtworzenia2Filter: "",
  osobaWysylajacaOdpraweFilter: [],
  osobaPrzygotowujacaOdpraweFilter: [],
  osobaMonitorujacaOdpraweFilter: [],
  osobaWeryfikujacaOdpraweFilter: [],
  lokalizacjaFilter: [],
  statusFilter: [],
  rodzajFilter: [],
  rodzajTransportuFilter: [],
  dokumentyFilter: [],
  fakturaCheckboxState: false,
  listPrzewozowyCheckboxState: false,
  kosztyTransportuCheckboxState: false,
  informacjeOTowarzeCheckboxState: false,
  T1CheckboxState: false,
  swiadectwoCheckboxState: false,
  upowaznienieCheckboxState: false,
  eoriCheckboxState: false,
  plikExcelZDanymiCheckboxState: false,
  certyfikatyCheckboxState: false,
  eksportZKrajuWywozuCheckboxState: false,
  sankcjeCheckboxState: false,
  CBAMCheckboxState: false,
  CECheckboxState: false,
  dskCheckboxState: false,
  plikCheckboxState: false,
  wiecejNiz3CheckboxState: false,
  kilkaRazyCheckboxState: false,
  zleconaPo16CheckboxState: false,
  bladWPrzygotowanejOdprawieCheckboxState: false,
  KWCheckboxState: false,
  brakFakturyEdytowalnejCHeckboxState: false,
  brakPackingListEdytowalnegoCheckboxState: false,
  brakIncotermsCheckboxState: false,
  oczekiwanieNaPlatnoscCheckboxState: false,
  ponownyMailOBrakiCheckboxState: false,
  RPSCheckboxState: false,
  WIJHARSCheckboxState: false,
  SingleWindowCheckboxState: false,
  ObecnoscPracownikaCheckboxState: false,
  COOCheckboxState: false,
  SanepidCheckboxState: false,
  WysylkaDokumentowCheckboxState: false,
  EURCheckboxState: false,
  T2LCheckboxState: false,
  ATRCheckboxState: false,
  rewizjaCheckboxState: false,
};

// ---------------------------------------------------------------------------
// Funkcja filtrująca dane (czysta, poza komponentem)
// ---------------------------------------------------------------------------

export const applyFilterWithParams = (data, f) => {
  let filteredData = data;
  const fmt = moment(f.dataUtworzeniaFilter);

  if (
    (f.osobaWysylajacaOdpraweFilter &&
      f.osobaWysylajacaOdpraweFilter.length > 0) ||
    (f.osobaPrzygotowujacaOdpraweFilter &&
      f.osobaPrzygotowujacaOdpraweFilter.length > 0) ||
    (f.osobaMonitorujacaOdpraweFilter &&
      f.osobaMonitorujacaOdpraweFilter.length > 0) ||
    (f.osobaWeryfikujacaOdpraweFilter &&
      f.osobaWeryfikujacaOdpraweFilter.length > 0)
  ) {
    filteredData = filteredData.filter(
      (item) =>
        (f.osobaWysylajacaOdpraweFilter &&
          f.osobaWysylajacaOdpraweFilter.includes(
            item.osobaWysylajacaOdprawe,
          )) ||
        (f.osobaPrzygotowujacaOdpraweFilter &&
          f.osobaPrzygotowujacaOdpraweFilter.includes(
            item.osobaPrzygotowujacaOdprawe,
          )) ||
        (f.osobaMonitorujacaOdpraweFilter &&
          f.osobaMonitorujacaOdpraweFilter.includes(
            item.osobaMonitorujacaOdprawe,
          )) ||
        (f.osobaWeryfikujacaOdpraweFilter &&
          f.osobaWeryfikujacaOdpraweFilter.includes(
            item.osobaWeryfikujacaOdprawe,
          )),
    );
  } else {
    if (
      f.osobaWysylajacaOdpraweFilter &&
      f.osobaWysylajacaOdpraweFilter.length > 0
    ) {
      filteredData = filteredData.filter((item) =>
        f.osobaWysylajacaOdpraweFilter.includes(item.osobaWysylajacaOdprawe),
      );
    }
    if (
      f.osobaPrzygotowujacaOdpraweFilter &&
      f.osobaPrzygotowujacaOdpraweFilter.length > 0
    ) {
      filteredData = filteredData.filter((item) =>
        f.osobaPrzygotowujacaOdpraweFilter.includes(
          item.osobaPrzygotowujacaOdprawe,
        ),
      );
    }
    if (
      f.osobaMonitorujacaOdpraweFilter &&
      f.osobaMonitorujacaOdpraweFilter.length > 0
    ) {
      filteredData = filteredData.filter((item) =>
        f.osobaMonitorujacaOdpraweFilter.includes(
          item.osobaMonitorujacaOdprawe,
        ),
      );
    }
    if (
      f.osobaWeryfikujacaOdpraweFilter &&
      f.osobaWeryfikujacaOdpraweFilter.length > 0
    ) {
      filteredData = filteredData.filter((item) =>
        f.osobaWeryfikujacaOdpraweFilter.includes(
          item.osobaWeryfikujacaOdprawe,
        ),
      );
    }
  }

  if (f.lokalizacjaFilter && f.lokalizacjaFilter.length > 0) {
    filteredData = filteredData.filter((item) =>
      f.lokalizacjaFilter.includes(item.lokalizacjaTowaru),
    );
  }
  if (f.statusFilter && f.statusFilter.length > 0) {
    filteredData = filteredData.filter((item) =>
      f.statusFilter.includes(item.statusRealizacji),
    );
  }
  if (f.rodzajFilter && f.rodzajFilter.length > 0) {
    filteredData = filteredData.filter((item) =>
      f.rodzajFilter.includes(item.rodzaj),
    );
  }
  if (f.dokumentyFilter && f.dokumentyFilter.length > 0) {
    filteredData = filteredData.filter((item) =>
      f.dokumentyFilter.includes(item.dokPrzedPrzybyciem),
    );
  }
  if (f.nrRefFilter) {
    const nrRefTokens = f.nrRefFilter
      .split(/[\n,]+/)
      .map((v) => v.trim().toLowerCase())
      .filter(Boolean);
    if (nrRefTokens.length > 0) {
      filteredData = filteredData.filter((item) => {
        if (item.nrRef == null) return false;
        const normalizedNrRef = String(item.nrRef).trim().toLowerCase();
        return nrRefTokens.some((token) => normalizedNrRef.includes(token));
      });
    }
  }
  if (
    f.nrFakturyFilter &&
    data.some((item) => item.nrFaktury !== null && item.nrFaktury !== undefined)
  ) {
    filteredData = filteredData.filter(
      (item) =>
        item.nrFaktury &&
        item.nrFaktury.toUpperCase().includes(f.nrFakturyFilter.toUpperCase()),
    );
  }
  if (
    f.adresatDokumentow &&
    data.some(
      (item) =>
        item.adresatDokumentow !== null && item.adresatDokumentow !== undefined,
    )
  ) {
    filteredData = filteredData.filter(
      (item) =>
        item.adresatDokumentow &&
        item.adresatDokumentow
          .toUpperCase()
          .includes(f.adresatDokumentow.toUpperCase()),
    );
  }
  if (f.dateFilter) {
    filteredData = filteredData.filter((item) =>
      moment(item.utworzono).format("DD-MM-YYYY").includes(f.dateFilter),
    );
  }
  if (
    f.importerFilter &&
    data.some((item) => item.importer !== null && item.importer !== undefined)
  ) {
    const lower = f.importerFilter.toLowerCase();
    filteredData = filteredData.filter(
      (item) => item.importer && item.importer.toLowerCase().includes(lower),
    );
  }
  if (
    f.eksporterFilter &&
    data.some((item) => item.eksporter !== null && item.eksporter !== undefined)
  ) {
    const lower = f.eksporterFilter.toLowerCase();
    filteredData = filteredData.filter(
      (item) => item.eksporter && item.eksporter.toLowerCase().includes(lower),
    );
  }
  if (
    f.autoFilter &&
    data.some(
      (item) =>
        item.nrRejestracyjnyPojazdyKurier !== null &&
        item.nrRejestracyjnyPojazdyKurier !== undefined,
    )
  ) {
    const lower = f.autoFilter.toLowerCase();
    filteredData = filteredData.filter(
      (item) =>
        item.nrRejestracyjnyPojazdyKurier &&
        item.nrRejestracyjnyPojazdyKurier.toLowerCase().includes(lower),
    );
  }
  if (
    f.MRNFilter &&
    data.some((item) => item.MRN !== null && item.MRN !== undefined)
  ) {
    const mrnTokens = f.MRNFilter.split(/[\n,]+/)
      .map((v) => v.trim().toLowerCase())
      .filter(Boolean);
    if (mrnTokens.length > 0) {
      filteredData = filteredData.filter((item) => {
        if (item.MRN == null) return false;
        const normalizedMRN = String(item.MRN).trim().toLowerCase();
        return mrnTokens.some((token) => normalizedMRN.includes(token));
      });
    }
  }
  if (f.SADFilter === "empty") {
    filteredData = filteredData.filter(
      (item) => item.SAD == null || String(item.SAD).trim() === "",
    );
  } else if (f.SADFilter) {
    const lower = f.SADFilter.toLowerCase();
    filteredData = filteredData.filter(
      (item) => item.SAD && item.SAD.toLowerCase().includes(lower),
    );
  }
  if (f.rodzajTransportuFilter && f.rodzajTransportuFilter.length > 0) {
    filteredData = filteredData.filter((item) =>
      f.rodzajTransportuFilter.includes(item.rodzajTransportu),
    );
  }
  if (f.startDate && f.endDate) {
    const s = new Date(f.startDate + "T00:00:00");
    const e = new Date(f.endDate + "T23:59:59.999");
    filteredData = filteredData.filter((item) => {
      const d = new Date(item["data"]);
      return d >= s && d <= e;
    });
  }
  if (f.dataUtworzeniaFilter) {
    filteredData = filteredData.filter((item) =>
      moment(item.utworzono).isSame(fmt, "day"),
    );
  }
  if (f.dataZakonczeniaFilter && f.dataZakonczenia1Filter) {
    const s = new Date(f.dataZakonczenia1Filter + "T00:00:00");
    const e = new Date(f.dataZakonczeniaFilter + "T23:59:59.999");
    filteredData = filteredData.filter((item) => {
      const d = new Date(item["endDate"]);
      return d >= s && d <= e;
    });
  }
  if (f.dataUtworzenia1Filter && f.dataUtworzenia2Filter) {
    const s = new Date(f.dataUtworzenia1Filter + "T00:00:00");
    const e = new Date(f.dataUtworzenia2Filter + "T23:59:59.999");
    filteredData = filteredData.filter((item) => {
      const d = new Date(item["utworzono"]);
      return d >= s && d <= e;
    });
  }

  const checkboxFilters = {
    faktura: f.fakturaCheckboxState,
    listPrzewozowy: f.listPrzewozowyCheckboxState,
    kosztyTransportu: f.kosztyTransportuCheckboxState,
    informacjeOTowarze: f.informacjeOTowarzeCheckboxState,
    T1: f.T1CheckboxState,
    swiadectwo: f.swiadectwoCheckboxState,
    brakUpowaznienia: f.upowaznienieCheckboxState,
    eori: f.eoriCheckboxState,
    brakExcel: f.plikExcelZDanymiCheckboxState,
    brakCertyfikaty: f.certyfikatyCheckboxState,
    brakEksportZKrajuWywozu: f.eksportZKrajuWywozuCheckboxState,
    sankcje: f.sankcjeCheckboxState,
    CBAM: f.CBAMCheckboxState,
    CE: f.CECheckboxState,
    pliki: f.plikCheckboxState,
    wiecejNiz3: f.wiecejNiz3CheckboxState,
    kilkaRazy: f.kilkaRazyCheckboxState,
    odprawaPo16: f.zleconaPo16CheckboxState,
    zglosBlad: f.bladWPrzygotowanejOdprawieCheckboxState,
    KW: f.KWCheckboxState,
    brakFakturyEdytowalnej: f.brakFakturyEdytowalnejCHeckboxState,
    brakPackingListEdytowalnego: f.brakPackingListEdytowalnegoCheckboxState,
    brakIncoterms: f.brakIncotermsCheckboxState,
    oczekiwanieNaPlatnosc: f.oczekiwanieNaPlatnoscCheckboxState,
    ponownyMailOBraki: f.ponownyMailOBrakiCheckboxState,
    RPS: f.RPSCheckboxState,
    WIJHARS: f.WIJHARSCheckboxState,
    SingleWindow: f.SingleWindowCheckboxState,
    ObecnoscPracownika: f.ObecnoscPracownikaCheckboxState,
    COO: f.COOCheckboxState,
    Sanepid: f.SanepidCheckboxState,
    WysylkaDokumentow: f.WysylkaDokumentowCheckboxState,
    EUR: f.EURCheckboxState,
    T2L: f.T2LCheckboxState,
    ATR: f.ATRCheckboxState,
    DSK: f.dskCheckboxState,
  };
  const checkedCheckboxes = Object.entries(checkboxFilters)
    .filter(([, isChecked]) => isChecked)
    .map(([checkbox]) => checkbox);
  if (checkedCheckboxes.length > 0) {
    filteredData = filteredData.filter((item) =>
      checkedCheckboxes.some((checkbox) => item[`${checkbox}Box`] === 1),
    );
  }
  if (f.rewizjaCheckboxState) {
    filteredData = filteredData.filter(
      (item) => item.rewizja === "Tak" || item.rewizja === "TAK",
    );
  }
  if (f.searchText) {
    const lower = f.searchText.toLowerCase();
    filteredData = filteredData.filter((row) =>
      Object.values(row)
        .map((v) => (v ? v.toString() : ""))
        .join(" ")
        .toLowerCase()
        .includes(lower),
    );
  }
  return filteredData;
};
